import React from 'react';

/**
 * Estilo de los botones de la columna «Acciones», literal del canon de
 * MasterCrud (`MasterCrudTable.tsx` → `ROW_ACTION_BTN`): es el MISMO diseño que
 * el botón secundario «Cancelar» del detalle, o sea el `Button` del kit con
 * `type="outline" color="primary" size="xs" iconOnly` (28x28).
 *
 * Vive aquí y no en cada tabla porque `MasterDocument` tiene DOS rejillas con
 * acciones por fila —el listado de documentos y la grilla de líneas— y con una
 * copia en cada una vuelven a divergir en el siguiente PR (ADR-027 §Apéndice C,
 * «un solo dueño del estilo»).
 *
 * La cadena se copia en vez de montar el `Button` por dos razones que ya
 * documenta MasterCrud: el kebab necesita `ref` para posicionar su portal y el
 * `Button` del kit no es `forwardRef`, y `buttonVariants` no se exporta.
 */
export const ROW_ACTION_BTN =
  'inline-flex items-center justify-center w-7 h-7 rounded-md font-medium whitespace-nowrap transition-all duration-150 cursor-pointer ' +
  'focus:outline-hidden focus:ring-4 focus:ring-offset-2 ' +
  'disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none ' +
  'bg-transparent border shadow-xs hover:brightness-98 dark:hover:brightness-102 ' +
  'text-primary-600 dark:text-primary-400 border-primary-300 dark:border-primary-700 ' +
  'hover:bg-primary-100 dark:hover:bg-primary-950 ' +
  'focus:ring-primary-400 focus:ring-offset-primary-100 dark:focus:ring-primary-500/50 dark:focus:ring-offset-gray-900';

/** Utilidades de tamaño de Tailwind (`w-4`, `h-3.5`, `size-4`, `w-[15px]`…). */
const UTILIDADES_DE_TAMANO =
  /(^|\s)(?:w|h|size)-(?:\d+(?:\.\d+)?|px|full|auto|screen|min|max|fit|\[[^\]]*\])(?=\s|$)/g;

/**
 * Encaja el icono de una acción en la caja de 15x15 del contenedor.
 *
 * El consumidor declara el icono con SU propia clase de tamaño —`w-4 h-4`, es
 * decir 16px— y esos 16 no caben en 15: el flex encoge el ancho y deja el alto,
 * así que el icono sale deformado. Se sustituyen SOLO las clases de tamaño por
 * `size-full` y se conserva el resto (color, `shrink-0`, transiciones). Es la
 * misma función que MasterCrud aplica en su celda de acciones.
 */
export function ajustarTamanoIcono(icono: React.ReactNode): React.ReactNode {
  if (!React.isValidElement<{ className?: string }>(icono)) return icono;
  const previas = icono.props.className ?? '';
  const sinTamano = previas.replace(UTILIDADES_DE_TAMANO, ' ').replace(/\s+/g, ' ').trim();
  return React.cloneElement(icono, { className: `${sinTamano} size-full`.trim() });
}
